/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Carousel } from 'antd'
import LazyLoad from 'react-lazyload'
import NoSSR from '@/components/rc-no-ssr'
import { UseGalleryModal } from '../../../gallery-modal'
import { useFavorite, useSlider } from './logic'
import imgCarDefaultSmall from '~/img/buy/loading-small.jpg'
import imgVideo from '~/img/buy/video.png'

import './index.scss'

const BasicSlider = ({ basic, otherData }) => {
  const { phone } = useSelector(store => store.user)
  const city = useSelector(store => store.city)
  const { fr, ino } = city
  const basicInfo = basic.basic_info
  const imgs = basic.images
  const miniSuffix = '?imageView/4/w/122/h/81'
  const middleSuffix = '?imageView/4/w/720/h/480'
  const { vr, video_url } = basicInfo

  // 收藏
  const [isFavorite, changeFavorite] = useFavorite({ carId: basic.carId })
  // 图片轮播
  const [slider, currentPicNum, offset, {
    prePic, nextPic, beforeGalleryChange, setCurrentPicNum
  }] = useSlider({ imgs })

  // 缩略图，加载当前将要滚动到的图片，以及前三张和后三张
  const lazyload = (current) => {
    const doms = Array.from(document.querySelectorAll('.r-basic-pic__thund .main img')).slice(current - 3, current + 3)
    doms.map(item => item.setAttribute('src', item.getAttribute('data-src')))
  }
  useEffect(() => { lazyload(currentPicNum) }, [currentPicNum])

  const onPicClick = (isVideoClick) => {
    global.$rbl.push('car-detail_image')
    global.$rbl.push('car-detail_pc-daigoudetailpage-images')
    global.$rbl.push('car-detail_basicinformation-carimage-size1_click')
    const submitParams = {
      mobile_number: phone || '',
      phone_source: `${fr}${ino ? '_异地' : ''}`
    }
    const otherParams = {
      ino, basicInfo, tags: basic.tags, images: basic.images, owner: otherData?.owner, phoneSource: city.phone_source
    }
    if (isVideoClick === true) {
      otherParams.isVideoClick = true
    }
    new UseGalleryModal({
      submitParams, otherParams, currentPicNum
    }).open()
  }


  const renderImgJsx = (img, index) => (
    <>
      <LazyLoad><img src={`${img.img_url}${middleSuffix}`} alt="车辆详情" /></LazyLoad>
      <div className="photo-txt clearfix">
        <div className="photo-title">
          {img.title} {img.desc}
        </div>
        <div className="photo-num">
          <i className="iconfont icon-pic" />
          {`${index + 1}/${vr ? imgs.length + 1 : imgs.length}`}
        </div>
      </div>
    </>
  )

  return (
    <div className="r-basic-pic">
      <div className="r-basic-pic__gallery">
        <NoSSR>
          {video_url && <img className="video" src={imgVideo} alt="video" data-click="cardetailpage_basic-video_click" onClick={() => onPicClick(true)} />}
          <Carousel lazyLoad dots={false} ref={slider} beforeChange={beforeGalleryChange}>
            {vr && (
              <>
                <a
                  key="vr"
                  href={vr.display_url}
                  className="img-box"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-click="car-detail_Vr_Click"
                  data-exposure="car-detail_Vr_Display"
                >
                  {renderImgJsx({ ...vr, img_url: vr.head_url }, 0)}
                  <div className="vr-icon"> <div className="panorama-animation" /></div>
                </a>
              </>
            )}
            {imgs && imgs.map((img, index) => (
              <div
                key={index}
                className="img-box"
                onClick={onPicClick}
              >
                {renderImgJsx(img, vr ? index + 1 : index)}
              </div>
            ))}
          </Carousel>
        </NoSSR>

        {/* 元素： 上一页、下一页、收藏 */}
        <div className="next" onClick={nextPic} data-click="car-detail_basicinformation-carimage-size1-right1_click">
          <i className="iconfont icon-middl_color_right-a4775df2" />
        </div>
        <div className="pre" onClick={prePic} data-click="car-detail_basicinformation-carimage-size1-left1_click">
          <i className="iconfont icon-middl_color_right-a4775df2" />
        </div>
        <div className="recommend clearfix">
          <div className="favorite" onClick={changeFavorite} data-click="car-detail_basicinformation-collect_click">
            {!isFavorite ? <i className="iconfont icon-heart" /> : <i className="iconfont icon-heart_s" />}
          </div>
          <div className="car-id">车源号：{basicInfo.rrc_id}</div>
        </div>

      </div>
      {/* 缩略图 */}
      {imgs?.length && (
        <div className="r-basic-pic__thund clearfix">
          <NoSSR>
            <div className="pre" onClick={prePic} data-click="car-detail_basicinformation-carimage-size2-left1_click">
              <i className="iconfont icon-middl_color_right-a4775df2" />
            </div>
            <div className="main">
              <ul className="clearfix" style={{ position: 'relative', left: `${offset}px` }}>
                {vr && (
                <li
                  key="vr"
                  className={`img-box ${currentPicNum === 0 ? 'active' : ''}`}
                  onClick={() => { setCurrentPicNum(0) }}
                >
                  <img src={`${vr.head_url}${miniSuffix}`} alt="vr" />
                </li>
                )}
                {imgs && imgs.map((img, index) => (
                  <li
                    key={index}
                    className={`img-box ${(vr ? index + 1 : index) === currentPicNum ? 'active' : ''}`}
                    onClick={() => { setCurrentPicNum(vr ? index + 1 : index) }}
                    data-click="car-detail_basicinformation-carimage-size2_click"
                  >
                    {index < 5 ? <img src={`${img.img_url}${miniSuffix}`} data-src={`${img.img_url}${miniSuffix}`} alt={img.anno} /> : <img src={imgCarDefaultSmall} data-src={`${img.img_url}${miniSuffix}`} alt={img.anno} />}
                  </li>
                ))}
              </ul>
            </div>
            <div className="next" onClick={nextPic} data-click="car-detail_basicinformation-carimage-size2-right1_click">
              <i className="iconfont icon-middl_color_right-a4775df2" />
            </div>
          </NoSSR>
        </div>
      )}
    </div>
  )
}

export default BasicSlider
